angular.module('invoice')
    .controller('InvoiceManagerialCategoryDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, InvoiceManagerialCategory) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = InvoiceManagerialCategory.update(this.item).$promise
            } else {
                promise = InvoiceManagerialCategory.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('invoice-managerial-category.updated')
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        };
    })
